import React from "react";
import { Typography, Autocomplete, TextField, Paper } from "@mui/material";

const EditFormSelect = ({ label, isEditing, handleInputChange, inputName, inputValue, options }) => {
    // Convert inputValue to string for consistent comparison
    const stringValue = inputValue ? inputValue.toString() : "";

    // Find the selected option - compare as strings to avoid type issues
    const selectedOption = options.find(option =>
        option.value.toString() === stringValue
    ) || null;

    return (
        <div className={'input-row d-flex'}>
            <Typography className={'input-label'}>
                {label}
            </Typography>
            {
                isEditing ? (
                    <Autocomplete
                        className={'edit-select'}
                        options={options}
                        getOptionLabel={(option) => option.label}
                        value={selectedOption}
                        onChange={(event, newValue) => {
                            handleInputChange(inputName, newValue ? newValue.value : "");
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                variant="standard"
                                fullWidth
                                className={'edit-input'}
                                InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true // Match original select style
                                }}
                            />
                        )}
                        PaperComponent={({ children }) => (
                            <Paper style={{ borderRadius: '4px', boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
                                {children}
                            </Paper>
                        )}
                        disableClearable // Optional: Disable clear button
                    />
                ) : (
                    <Typography className={'input-label'}>
                        {selectedOption ? selectedOption.label : inputValue}
                    </Typography>
                )
            }
        </div>
    );
};

export default EditFormSelect;